// src/components/pages/Movimento/profiles/operacoes/index.js

export const operacaoOverrides = {
    // Entradas
    ODC: {
        id: 'ODC',
        layout: 'entrada',
        natureza: 'Entrada',
        tabs: {
            frete: { enabled: true },
        },
        uiTabs: {
            cabecalho: {
                labels: {
                    labColaborador: 'Comprador',
                    labParceiro: 'Fornecedor',
                },
            },
            itens: {
                digitaDatalistProduto: true,
                show: { precoNegociado: true },
            },
        },
    },
    PDC: {
        id: 'PDC',
        layout: 'entrada',
        natureza: 'Entrada',
        tabs: {
            frete: { enabled: true },
        },
        uiTabs: {
            cabecalho: {
                labels: { labColaborador: 'Comprador', labParceiro: 'Fornecedor' },
            },
            itens: { digitaDatalistProduto: true, show: { precoNegociado: true } },
        },
    },
    OMP: {
        id: 'OMP',
        layout: 'entrada',
        natureza: 'Entrada',
        tabs: {
            frete: { enabled: true },
        },
        uiTabs: {
            cabecalho: {
                labels: {
                    labColaborador: 'Comprador',
                    labParceiro: 'Fornecedor',
                },
            },
            itens: { digitaDatalistProduto: true, show: { precoNegociado: true } },
        },
    },
    PMP: {
        id: 'PMP',
        layout: 'entrada',
        natureza: 'Entrada',
        tabs: {
            frete: { enabled: true },
        },
        uiTabs: {
            cabecalho: {
                labels: { labColaborador: 'Comprador', labParceiro: 'Fornecedor' },
            },
            itens: { digitaDatalistProduto: true, show: { precoNegociado: true } },
        },
    },

    // Saidas
    ODV: {
        id: 'odv',
        layout: 'vendas',
        natureza: 'Saida',
        parceiroVai: 'destinatario',

        uiTabs: {
            cabecalho: {
                labels: { labColaborador: 'Vendedor', labParceiro: 'Cliente' },
                show: { pedidoPadrao: true },
            },
            itens: {
                show: { precoNegociado: true, precoPorUnidade: true },
            },
        },
        parametros: {
            cabecalho: {},
            financeiro: {},
            itens: {
                usaTabelaPreco: true,
            },
        },
    },
    PDV: {
        id: 'pdv',
        layout: 'vendas',
        natureza: 'Saida',
        parceiroVai: 'destinatario',
        uiTabs: {
            cabecalho: {
                labels: { labColaborador: 'Vendedor', labParceiro: 'Cliente' },
                show: { pedidoPadrao: true },
            },
            itens: {
                show: { precoNegociado: true, precoPorUnidade: true },
            },
        },
        parametros: {
            cabecalho: {},
            financeiro: {},
            itens: {
                usaTabelaPreco: true,
            },
        },
    },
    /* possuem particularidades telas específicas */
    LIM: {
        id: 'imoveis',
        layout: 'imoveis',
        natureza: 'Saida',

        // ✅ LIM usa tabs específicas
        tabs: {
            cabecalho: { enabled: true },
            financeiro: { enabled: false },

            // LIM NÃO usa "itens" padrão; usa "imovel"
            itens: { enabled: false },
            imovel: { enabled: true },

            lancamento: { enabled: false },
            observacao: { enabled: true },
            aditivo: { enabled: true },

            // se quiser manter por enquanto
            assinatura: { enabled: false },
            frete: { enabled: false }, // ou true se LIM tiver
        },
        uiTabs: {
            cabecalho: {
                labels: {
                    labColaborador: 'Corretor',
                    labParceiro: 'Locatário',
                    labParceiroVinculado: 'Fiador',
                    labAdministrador: 'Administrador',
                },
                show: {
                    //padrão é mostrar tudo, os profiles vão desligando o que não quiserem
                    empresa: false,
                    datasBasicas: true, // cadastro e update
                    //movimento
                    situacao: true,
                    //pessoas vinculadas ao movimento
                    administrador: true,
                    parceiro: true,
                    parceiroVinculado: true,
                    colaborador: true,
                    //financeiro
                    financeiroCabecalho: true,
                    financeiro: true,
                    centroCusto: true,
                    conta: true,
                    forma: true,
                    prazo: true,
                    provisao: true,
                    //comissao
                    comissao: true,
                    //endereço
                    endereco: false,
                    //logistica
                    almoxarifado: false,
                    dataPrevista: false,
                },
            },
            itens: {},
        },
        parametros: {
            cabecalho: {
                parceiroVinculado: {
                    fiador: true, //filtra os parceiros vinculados que são fiadores
                },
            },
            financeiro: {},
            itens: {
                usaTabelaPreco: true,
                digitaDatalistProduto: true,
            },
            lancamento: {},
            observacao: {},
            frete: {},
            aditivo: {},
            assinatura: {},
            obrigaAlmoxarifado: false,
        },
    },
    REST: {
        id: 'restaurante',
        layout: 'restaurante',
        natureza: 'Saida',

        // tabs (desliga as padrão e liga as do REST)
        tabs: {
            cabecalho: { enabled: false }, // REST não usa cabecalho “tradicional”
            financeiro: { enabled: false },
            lancamento: { enabled: false },
            frete: { enabled: false },
            itens: { enabled: true },
            imovel: { enabled: false },
            observacao: { enabled: true },
            assinatura: { enabled: true },
        },
        uiTabs: {
            cabecalho: {
                labels: {
                    labColaborador: 'Vendedor',
                    labParceiro: 'Cliente',
                    labParceiroVinculado: 'Fiador',
                    labAdministrador: 'Administrador',
                },
            },
            itens: { precoNegociado: true },
        },
        function: {},
        parametros: {
            cabecalho: {},
            financeiro: {},
            itens: {
                usaTabelaPreco: true,
                digitaDatalistProduto: true,
                datalistProdutoFiltraPorDiaHora: true,
                quantidadePadrao: 1,
                valorUnitarioIndexado: true,
            },
            lancamento: {},
            observacao: {},
            frete: {},
            aditivo: {},
            assinatura: {},
            parceiroPadrao: true,
            financeiroPadrao: true,
            obrigaAlmoxarifado: false,
            //parceiroIdGeraCustoFilial: true,
        },
    },

    // Serviços
    OSER: {
        id: 'oser',
        layout: 'oser',
        natureza: 'Saida',

        tabs: {
            cabecalho: { enabled: true },
            financeiro: { enabled: false },
            itens: { enabled: true },
            lancamento: { enabled: true },
            observacao: { enabled: true },
            assinatura: { enabled: true },
        },
        uitabs: {
            itens: {
                precoNegociado: true,
                usaTabelaPreco: false,
                digitaDatalistProduto: false,
                valorUnitarioIndexado: false,
                //uis e tabs
                almoxarifado: false,
                disponivel: false,
            },
        },
    },
    SER: {
        id: 'ser',
        layout: 'ser',
        natureza: 'Saida',

        tabs: {
            cabecalho: { enabled: true },
            financeiro: { enabled: false },
            itens: { enabled: true },
            lancamento: { enabled: true },
            observacao: { enabled: true },
            assinatura: { enabled: true },
        },
        uiTabs: {
            cabecalho: {
                labels: {
                    labColaborador: 'Colaborador Responsável',
                    labParceiro: 'Cliente',
                },
                show: { almoxarifado: false },
            },
            itens: {
                precoNegociado: true,
                usaTabelaPreco: true,
                digitaDatalistProduto: false,
                valorUnitarioIndexado: false,
                //uis e tabs
                disponivel: false,
                show: { almoxarifado: false, disponivel: false },
            },
            observacao: {
                obsEntrada: false,
                obsLancamento: true,
                obsMovimento: false,
                obsRequisicao: false,
                obsSaida: false,
                obsServico: true,
            },
        },
        parametros: {
            cabecalho: {},
            financeiro: {},
            itens: { usaTabelaPreco: true },
            lancamento: {},
            observacao: {},
            frete: {},
            aditivo: {},
            assinatura: {},
            obrigaAlmoxarifado: false,
        },
    },
    SERAV: {
        id: 'serav',
        layout: 'serav',
        natureza: 'Entrada',

        tabs: {
            cabecalho: { enabled: true },
            financeiro: { enabled: false },
            itens: { enabled: true },
            lancamento: { enabled: true },
            observacao: { enabled: true },
            assinatura: { enabled: true },
        },

        uiTabs: {
            cabecalho: {
                labels: {
                    labColaborador: 'Colaborador Responsável',
                    labParceiro: 'Prestador',
                },
                show: {
                    almoxarifado: false,
                    dataPrevista: false,
                },
            },
            itens: {
                usaTabelaPreco: true,
                digitaDatalistProduto: true,
                show: {
                    almoxarifado: false,
                    precoNegociado: true,
                },
            },
            observacao: {
                obsEntrada: false,
                obsLancamento: true,
                obsMovimento: false,
                obsRequisicao: false,
                obsSaida: false,
                obsServico: true,
            },
        },
        parametros: {
            cabecalho: {},
            financeiro: {},
            itens: {
                usaTabelaPreco: true,
            },
            lancamento: {},
            observacao: {},
            frete: {},
            aditivo: {},
            assinatura: {},
            obrigaAlmoxarifado: false,
        },
    },

    //profiles de LOGISTICA
    BAL: {
        id: 'BAL',
        layout: 'balanco',
        natureza: null,
        filtroProduto: false,
        tabs: {
            cabecalho: { enabled: true },
            balanco: { enabled: true },
            financeiro: { enabled: false },
            itens: { enabled: false },
            lancamento: { enabled: false },
            observacao: { enabled: false },
            assinatura: { enabled: false },
        },
        uiTabs: {
            cabecalho: {
                labels: {
                    labColaborador: 'Conferente',
                    labParceiro: 'Contador',
                    labAdministrador: 'Administrador',
                },
                // disabilita campos
                disabled: {
                    centroCustoId: true,
                    Colaborador: false,
                },
                readonly: {
                    parceiro: false,
                },
                show: {
                    empresa: true,
                    centroCusto: false,
                    endereco: false,
                    volumes: false,
                    //pessoas vinculadas ao movimento
                    administrador: true,
                },
            },
            itens: {
                show: {
                    permiteItemDuplicado: true,
                    almoxarifado: true,
                    volumes: true,
                    volumesTotal: true,
                    dataConferencia: true,
                    situacaoId: true,

                    //financeiro
                    precoNegociado: true,
                    precoPorUnidade: true,
                    valorUnitario: true,
                    descontoPercentual: true,
                    descontoValor: true,
                    valorTotal: true,
                    totalValor: true,
                },
            },
            observacao: {},
        },
        parametros: {
            parceiroPadrao: false,
        },
    },
    CFR: {
        id: 'CFR',
        layout: 'conferencia',
        natureza: null,
        filtroProduto: false,

        tabs: {
            cabecalho: { enabled: true },
            financeiro: { enabled: false },
            itens: { enabled: true },
            lancamento: { enabled: true },
            observacao: { enabled: true },
            assinatura: { enabled: true },
        },
        uiTabs: {
            cabecalho: {
                // labels variam conforme natureza
                labelsByNatureza: {
                    Entrada: {
                        labColaborador: 'Comprador',
                        labParceiro: 'Fornecedor',
                    },
                    Saida: {
                        labColaborador: 'Vendedor', // ou "Vendedor"
                        labParceiro: 'Cliente', // ou "Destinatário"
                    },
                },
                // disabilita campos
                disabled: {
                    centroCustoId: false,
                },
                readonly: {
                    parceiro: true,
                    cep: true,
                    Logradouro: true,
                    numero: true,
                    bairro: true,
                    complemento: true,
                    uf: true,
                    municipio: true,
                },
                show: {
                    empresa: false,
                    volumes: true,
                },

                // se quiser manter defaults do cabeçalho
                // (ou desligar/ligar campos específicos do CFR)
                // situacao: true,
                // ...
            },
            itens: {
                show: {
                    permiteItemDuplicado: true,
                    almoxarifado: true,
                    volumes: true,
                    volumesTotal: true,
                    dataConferencia: true,
                    situacaoId: true,

                    //financeiro
                    precoNegociado: true,
                    precoPorUnidade: true,
                    valorUnitario: true,
                    descontoPercentual: true,
                    descontoValor: true,
                    valorTotal: true,
                    totalValor: true,
                },
            },
            observacao: {},
        },
        itens: {
            usaTabelaPreco: false,
            digitaDatalistProduto: true,
        },
        parametros: {
            itens: {
                digitaDatalistProduto: false,
            },
        },
    },

    //profiles da INDUSTRIA
    SEP: {
        id: 'SEP',
        layout: 'industria',
        natureza: null,

        tabs: {
            financeiro: { enabled: false },
            lancamento: { enabled: false },
        },
        uiTabs: {
            cabecalho: {
                labels: {
                    labColaborador: 'Colaborador',
                    labParceiro: 'Parceiro',
                    labParceiroVinculado: 'Parceiro Vinculado',
                    labAdministrador: 'Administrador',
                },
                disabled: {
                    centroCustoId: false,
                    Colaborador: false,
                },
                readonly: {
                    parceiro: false,
                    cep: false,
                    Logradouro: false,
                    numero: false,
                    bairro: false,
                    complemento: false,
                    uf: false,
                    municipio: false,
                },
                show: {
                    empresa: false,
                    situacao: true,

                    administrador: false,
                    parceiro: true,
                    parceiroVinculado: false,
                    colaborador: true,
                    endereco: true,
                    almoxarifado: true,
                    dataPrevista: false,
                },
            },
            financeiro: {},
            itens: {
                labels: {
                    labColaborador: 'Colaborador',
                    labParceiro: 'Fornecedor',
                    labParceiroVinculado: 'Parceiro Vinculado',
                    labAdministrador: 'Administrador',
                },
                show: {
                    permiteItemDuplicado: false,
                    almoxarifado: true,
                    disponivel: false,
                    //financeiro
                    valorUnitario: false,
                    descontoPercentual: false,
                    descontoValor: false,
                    valorTotal: false,
                    totalValor: false,
                    //industria SEPARACAO
                    conferenciaCodigo: true,
                    refugo: true,
                    parceiroItem: true,
                    colaboradorItem: true,
                },
                usaTabelaPreco: false,
                digitaDatalistProduto: true, //consulta o produto por digitação no datalist
                datalistProdutoFiltraPorDiaHora: false, //filtra os produtos do datalist por dia e hora (ex: restaurante)
                quantidadePadrao: 0,
                valorUnitarioIndexado: false, //quando por regra da operação o valorUnitário é um valor indexado e mantém para desindexar o precoBase
            },
            lancamento: {},
            observacao: {
                obsEntrada: false,
                obsLancamento: true,
                obsMovimento: true,
                obsRequisicao: false,
                obsSaida: false,
                obsServico: false,
            },
            frete: {},
            aditivo: {},
            assinatura: {},
        },
        function: {
            atualizaDadosParceiro: true, //ao mudar dados.parceiroId atualizar os dados, uzado em parceiroPadrao
        },
        parametros: {
            cabecalho: {},
            financeiro: {},
            itens: {
                usaTabelaPreco: false,
                digitaDatalistProduto: false, //consulta o produto por digitação no datalist
                datalistProdutoFiltraPorDiaHora: false, //filtra os produtos do datalist por dia e hora (ex: restaurante)
                quantidadePadrao: 0,
                valorUnitarioIndexado: false, //quando por regra da operação o valorUnitário é um valor indexado e mantém para desindexar o precoBase
            },
            lancamento: {},
            observacao: {
                obsEntrada: false,
                obsLancamento: false,
                obsMovimento: true,
                obsRequisicao: false,
                obsSaida: false,
                obsServico: false,
            },
            frete: {},
            aditivo: {},
            assinatura: {},

            //defaults para o sistema e não apenas para abas
            obrigaAlmoxarifado: true,
            parceiroPadrao: true, //movimento obtem o parceiro de parametro.pessoaId
            financeiroPadrao: false, //quando true => operacaoParametros injeta formaId, prazoId, contaId, centroCustoId por padrão false => ao selecionar o parceiroId faz a busca
            //parceiroIdGeraCustoFilial: false, //quando a empresa banca a despesa e no caso da fililal gera um pagamento para a empresa do colaborador
        },
    },
    OP: {
        id: 'OP',
        layout: 'industria',
        natureza: null,

        tabs: {
            financeiro: { enabled: false },
            lancamento: { enabled: false },
        },
        uiTabs: {
            cabecalho: {
                labels: {
                    labColaborador: 'Colaborador',
                    labParceiro: 'Parceiro',
                    labParceiroVinculado: 'Parceiro Vinculado',
                    labAdministrador: 'Administrador',
                },
                disabled: {
                    centroCustoId: false,
                    Colaborador: false,
                },
                readonly: {
                    parceiro: false,
                    cep: false,
                    Logradouro: false,
                    numero: false,
                    bairro: false,
                    complemento: false,
                    uf: false,
                    municipio: false,
                },
                show: {
                    empresa: false,
                    situacao: true,

                    administrador: false,
                    parceiro: true,
                    parceiroVinculado: false,
                    colaborador: true,
                    endereco: true,
                    almoxarifado: true,
                    dataPrevista: false,
                },
            },
            financeiro: {},
            itens: {
                labels: {
                    labColaborador: 'Operador',
                    labParceiro: 'Fornecedor',
                    labParceiroVinculado: 'Parceiro Vinculado',
                    labAdministrador: 'Administrador',
                },
                show: {
                    permiteItemDuplicado: false,
                    almoxarifado: true,
                    disponivel: false,
                    //financeiro
                    valorUnitario: false,
                    descontoPercentual: false,
                    descontoValor: false,
                    valorTotal: false,
                    totalValor: false,
                    //industria SEPARACAO
                    conferenciaCodigo: false,
                    refugo: false,
                    parceiroItem: false,
                    colaboradorItem: true,
                    //industria OP
                    producaoMinima: true,
                    sugestao: true,
                },
                usaTabelaPreco: false,
                digitaDatalistProduto: true, //consulta o produto por digitação no datalist
                datalistProdutoFiltraPorDiaHora: false, //filtra os produtos do datalist por dia e hora (ex: restaurante)
                quantidadePadrao: 0,
                valorUnitarioIndexado: false, //quando por regra da operação o valorUnitário é um valor indexado e mantém para desindexar o precoBase
            },
            lancamento: {},
            observacao: {
                obsEntrada: false,
                obsLancamento: true,
                obsMovimento: true,
                obsRequisicao: false,
                obsSaida: false,
                obsServico: false,
            },
            frete: {},
            aditivo: {},
            assinatura: {},
        },
        function: {
            atualizaDadosParceiro: true, //ao mudar dados.parceiroId atualizar os dados, uzado em parceiroPadrao
        },
        parametros: {
            cabecalho: {},
            financeiro: {},
            itens: {
                usaTabelaPreco: false,
                digitaDatalistProduto: false, //consulta o produto por digitação no datalist
                datalistProdutoFiltraPorDiaHora: false, //filtra os produtos do datalist por dia e hora (ex: restaurante)
                quantidadePadrao: 0,
                valorUnitarioIndexado: false, //quando por regra da operação o valorUnitário é um valor indexado e mantém para desindexar o precoBase
            },
            lancamento: {},
            observacao: {
                obsEntrada: false,
                obsLancamento: false,
                obsMovimento: true,
                obsRequisicao: false,
                obsSaida: false,
                obsServico: false,
            },
            frete: {},
            aditivo: {},
            assinatura: {},

            //defaults para o sistema e não apenas para abas
            obrigaAlmoxarifado: true,
            parceiroPadrao: true, //movimento obtem o parceiro de parametro.pessoaId
            financeiroPadrao: false, //quando true => operacaoParametros injeta formaId, prazoId, contaId, centroCustoId por padrão false => ao selecionar o parceiroId faz a busca
            //parceiroIdGeraCustoFilial: false, //quando a empresa banca a despesa e no caso da fililal gera um pagamento para a empresa do colaborador
        },
    },

    /* operações internas da empresa */
    REQ: {
        id: 'REQ',
        layout: 'requisicao',
        natureza: 'Saida',

        tabs: {
            financeiro: { enabled: false },
            lancamento: { enabled: false },
        },
        uiTabs: {
            cabecalho: {
                labels: {
                    labColaborador: 'Colaborador',
                    labParceiro: 'Parceiro',
                    labParceiroVinculado: 'Parceiro Vinculado',
                    labAdministrador: 'Administrador',
                },
                disabled: {
                    centroCustoId: false,
                    Colaborador: false,
                },
                readonly: {
                    parceiro: false,
                    cep: false,
                    Logradouro: false,
                    numero: false,
                    bairro: false,
                    complemento: false,
                    uf: false,
                    municipio: false,
                },
                show: {
                    empresa: true,
                    situacao: true,

                    administrador: false,
                    parceiro: true,
                    parceiroVinculado: false,
                    colaborador: true,
                    endereco: false,
                    almoxarifado: true,
                    dataPrevista: true,
                },
            },
            financeiro: {},
            itens: {
                labels: {
                    labColaborador: 'Operador',
                    labParceiro: 'Fornecedor',
                    labParceiroVinculado: 'Parceiro Vinculado',
                    labAdministrador: 'Administrador',
                },
                show: {
                    permiteItemDuplicado: false,
                    almoxarifado: true,
                    disponivel: true,
                    //financeiro
                    geraFinanceiro: false,
                    valorUnitario: false,
                    descontoPercentual: false,
                    descontoValor: false,
                    valorTotal: false,
                    totalValor: false,
                    //industria SEPARACAO
                    conferenciaCodigo: false,
                    refugo: false,
                    parceiroItem: false,
                    colaboradorItem: false,
                    //industria OP
                    producaoMinima: false,
                    sugestao: false,
                },
                usaTabelaPreco: false,
                digitaDatalistProduto: false, //consulta o produto por digitação no datalist
                datalistProdutoFiltraPorDiaHora: false, //filtra os produtos do datalist por dia e hora (ex: restaurante)
                quantidadePadrao: 0,
                valorUnitarioIndexado: false, //quando por regra da operação o valorUnitário é um valor indexado e mantém para desindexar o precoBase
            },
            lancamento: {},
            observacao: {
                obsEntrada: false,
                obsLancamento: true,
                obsMovimento: true,
                obsRequisicao: false,
                obsSaida: false,
                obsServico: false,
            },
            frete: {},
            aditivo: {},
            assinatura: {},
        },
        function: {
            atualizaDadosParceiro: true, //ao mudar dados.parceiroId atualizar os dados, uzado em parceiroPadrao
        },
        parametros: {
            cabecalho: {},
            financeiro: {},
            itens: {
                usaTabelaPreco: false,
                digitaDatalistProduto: false, //consulta o produto por digitação no datalist
                datalistProdutoFiltraPorDiaHora: false, //filtra os produtos do datalist por dia e hora (ex: restaurante)
                quantidadePadrao: 0,
                valorUnitarioIndexado: false, //quando por regra da operação o valorUnitário é um valor indexado e mantém para desindexar o precoBase
            },
            lancamento: {},
            observacao: {
                obsEntrada: false,
                obsLancamento: false,
                obsMovimento: true,
                obsRequisicao: false,
                obsSaida: false,
                obsServico: false,
            },
            frete: {},
            aditivo: {},
            assinatura: {},

            //defaults para o sistema e não apenas para abas
            obrigaAlmoxarifado: true,
            parceiroPadrao: true, //movimento obtem o parceiro de parametro.pessoaId
            financeiroPadrao: true, //quando true => operacaoParametros injeta formaId, prazoId, contaId, centroCustoId por padrão false => ao selecionar o parceiroId faz a busca
            //parceiroIdGeraCustoFilial: false, //quando a empresa banca a despesa e no caso da fililal gera um pagamento para a empresa do colaborador
        },
    },

    /* operações CONTABÉIS */
    XML: {
        id: 'XML',
        layout: 'entrada',
        natureza: 'Entrada',
        contabil: true,
        tabs: {
            frete: { enabled: true },
        },
        uiTabs: {
            cabecalho: {
                labels: { labColaborador: 'Comprador', labParceiro: 'Fornecedor' },
                show: { chNFe: true, serie: true },
            },
            itens: {
                show: { cfop: true, precoNegociado: true },
            },
        },
    },
};
